import React, { useState } from 'react';
import './ViewDetailComponent.css';
import Menu from '@material-ui/core/Menu';
import FadeLoader from "react-spinners/FadeLoader";
import { getDesignCriteria } from "../../../Actions/postActions";
import { overridedesigncriteria } from "@safecv/shared/sharedFunction";
import DesignCriteria from "../../../assets/Images/design_criteria_new.svg";

const DesignCriteriaMenu = (props) => {

  const { jobId, headerHeight } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [criteriaValue, setCriteriaValue] = useState("");
  const [loadingCriteria,setLoadingCriteria] = useState(false);
    
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setLoadingCriteria(true)
    handlegetValue();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlegetValue = async() => {
    const value = await getDesignCriteria(jobId)
    setCriteriaValue(value?.description)
    setLoadingCriteria(false)
  }

  return (
    <>
      <img
        alt=""
        src={DesignCriteria}
        onClick={handleClick}
        title="Design Criteria"
        className="header-design-criteria"
      />
      <div className="separator-line" />
      <Menu
        id="menu"
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        anchorOrigin={{ vertical: headerHeight - headerHeight / 3.2, horizontal: "left" }}
        PaperProps={{
          style: {
            borderRadius: "5px",
          },
        }}
      >
        <div className="header-design-criteria-menu flex-box">

          <div className="header-design-criteria-heading">DESIGN CRITERIA</div>

          <div style={{ overflow: "hidden" }}>
            {loadingCriteria ? (
              <FadeLoader
                width={5}
                radius={2}
                margin={2}
                height={15}
                css={overridedesigncriteria}
                color={"#4183C5"}
                loading={loadingCriteria}
              />
            ) : (
              <div className="static-viewdetail header-design-criteria-text">
                {criteriaValue ? criteriaValue : <span className="header-design-criteria-notext">No design criteria provided</span>}
              </div>
            )}
          </div> 

        </div>
      </Menu>
    </>
  );
}

export default DesignCriteriaMenu;